
import * as __star__ from '@ckeditor/ckeditor5-select-all/dist/index.js';

const {

SelectAll,
SelectAllCommand,
SelectAllEditing,
SelectAllUI,
__esModule
} = __star__;

export {
SelectAll,
SelectAllCommand,
SelectAllEditing,
SelectAllUI,
__esModule
};

